
// Import react elements
import React, { useEffect } from "react";

// Import hooks
import useCustomProductsData from "../../hooks/useCustomProductsData";

// Import components
import CreateButton from "global/components/CreateButton";
import TwoColumnList from "global/components/TwoColumnList";
import { Grid } from "global/components/Grid";
import { CloseIcon } from "global/strich_icons/StrichIcons";
import { InfoButton } from "global/components/InfoButton";



// Render add new surface pop up
const RenderAddNewPrintAreaPopup = ({ isOpen, onClose, handleSaveNewPrintArea, printAreaRoles, setPrintAreaRoles }) => {


    
    // Custom hook for fetching and managing product data
    const {
        fetchPrintAreaRoles
    } = useCustomProductsData();



    // To get print area roles for select dropdown
    useEffect(() => {

        // Check if there's any print area roles
        if (!printAreaRoles) {

            // There isn't so fetch them and set them
            fetchPrintAreaRoles(setPrintAreaRoles);
        }

    // Re run when printAreaRoles changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [printAreaRoles]);



    // If isOpen is false return early (don't show the pop up)
    if (!isOpen) return null;

    return (

        <div className="popup-overlay">
        
            <div className="popup-container popup-container--small" style={{height: "auto"}}>

                {/* This is the modal header */}
                <div className="popup__header">

                    {/* This is the title area */}
                    <div className="popup__headerLeft">

                        {/* This is the parent title */}
                        <h2 className="popup__title">

                            Add Print Area

                        </h2>

                        {/* This is the parent subtitle */}
                        <p className="popup__subtitle">

                        </p>

                    </div>

                    {/* This is the header actions */}
                    <div className="popup__headerRight">

                        {/* This is the close button */}
                        <button type="button" className="popup__close" onClick={() => onClose?.()} title="Close">
                            <CloseIcon />
                        </button>

                    </div>

                </div>

                <div className="popup-content popup-content__body">

                    <Grid className={"popup_grid-container"} >

                        <form

                                // Add a submit handler to the form
                            onSubmit={(event) => {

                                // Prevent the browser's default form submission (page reload)
                                event.preventDefault();

                                // Get a reference to the form element that triggered the submit
                                const formElement = event.currentTarget;

                                // Create a FormData object from the form element
                                const formData = new FormData(formElement);

                                // Create an empty object to hold the plain key/value pairs
                                const values = {};

                                // Loop over all entries in the FormData
                                formData.forEach((value, key) => {

                                    // Assign each key/value pair to the values object
                                    values[key] = value;

                                });

                                // Store an empty print profit as null
                                if (values.nominal_print_profit === "") {
                                    values.nominal_print_profit = null;
                                }

                                // Call save handler, passing the code and the values object
                                handleSaveNewPrintArea(values);

                            }}
                        
                        >

                            <TwoColumnList 
                                property={<label>Name</label>} 
                                value={<input 
                                    name="name" 
                                    type="text" 
                                    placeholder="Name" 
                                    required
                                />} 
                            />
                            <TwoColumnList 
                                property={<label>Code</label>} 
                                value={<input 
                                    name="code" 
                                    type="text" 
                                    placeholder="Code"
                                    required 
                                />} 
                            />
                            <br/>
                            
                            
                            <TwoColumnList 
                                property={<label>Width (mm)</label>} 
                                value={<input 
                                    name="width" 
                                    type="number"
                                    min="0"
                                    step="0.0001"
                                    placeholder="0.00"
                                    required 
                                />} 
                            />
                            <TwoColumnList 
                                property={<label>Height (mm)</label>} 
                                value={<input 
                                    name="height" 
                                    type="number" 
                                    min="0"
                                    step="0.0001"
                                    placeholder="0.00"
                                    required 
                                />} 
                            />
                            <p><span style={{fontSize: "smaller"}}>Ensure width and height are entered correctly as they cannot be edited later.</span></p>
                            <br/>
                            <TwoColumnList property={<label>Role </label>} value={
                                <select
                                    name="role"                                       
                                >
                                    <option value="">Select...</option>
                                    
                                    {printAreaRoles?.map((role) =>

                                        // Map through printAreaRoles to create the dropdown
                                        <option key={role.role} value={role.role} title={role.description}>{role.name} ({role.role})</option>

                                    )}
                                </select>} 
                            />

                            <TwoColumnList
                                property={<label>Print Price</label>}
                                value={
                                    <input
                                        name="nominal_print_price"
                                        type="number"
                                        min="0"
                                        step="any"
                                        placeholder="Print Price"
                                        required
                                    />
                                }
                            />

                            <TwoColumnList
                                property={
                                    <>
                                        <label>Print Profit</label>

                                        <InfoButton
                                            shortLabel="Print Profit"
                                            description="A minimim profit amount for this print area. This is used to calculate the RRP based on the configuration of the product and it's print areas."
                                        />
                                    </>
                                }
                                value={
                                    <input
                                        name="nominal_print_profit"
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        placeholder="Print Profit"
                                    />
                                }
                            />

                            <br/>
                            <br/>

                            {/* Footer actions */}
                            <div className="tabs-footer tabs-footer--no-background">

                                <CreateButton type="submit" title="Save" size="m" />

                                <CreateButton type="button" title="Cancel" isCancel={true} invert size="m" onClick={onClose} />
                                
                            </div>

                        </form>

                    </Grid>

                </div>

            </div>

        </div>
    )

}; export default RenderAddNewPrintAreaPopup;